import React from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import allotmentImg from "../../../assets/nw/Untitled-design-34.png";

const AllotmentSection = () => {
  return (
    <Box
      sx={{
        maxWidth: "1200px",
        mx: "auto",
        my: 4,
        px: 2,
      }}
    >
      <Grid
        container
        spacing={4}
        alignItems="center"
        justifyContent="space-between"
      >
        {/* Left Section */}
        <Grid item xs={12} md={6}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "#006769",
              mb: 2,
            }}
          >
            ALLOTMENT
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#555",
              lineHeight: 1.8,
              textAlign: "justify",
            }}
          >
            Allotment of sites from society in accordance with the guidelines
            issued by the government. As per the government, the allotment of
            various categories [30×30, 30×40, 30×50, 40×60, 50×80] will be
            completely based on a first booked, first served basis (seniority or
            first-come-first-serve basis).
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mt: 2,
              color: "#555",
              lineHeight: 1.8,
              textAlign: "justify",
            }}
          >
            The layout map will be displayed in front of all members while
            selecting the sites.
          </Typography>

          <Button
            variant="contained"
            sx={{
              mt: 3,
              backgroundColor: "#006769",
              textTransform: "none",
              px: 4,
              py: 1,
              borderRadius: "25px",
              fontWeight: "600",
              fontSize: "16px",
              "&:hover": {
                backgroundColor: "#044a4bff",
              },
            }}
          >
            Get Quote
          </Button>
        </Grid>

        {/* Right Section */}
        <Grid item xs={12} md={6}>
          <Box
            component="img"
            src={allotmentImg}
            alt="Allotment"
            sx={{
              width: "100%",
              borderRadius: "20px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
              transition: "transform 0.3s ease-in-out",
              "&:hover": {
                transform: "scale(1.03)",
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AllotmentSection;
